import React from 'react';
import { Heading1, Heading3, Paragraph } from '../../components/typography';
import { Row, Col, Container } from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import TheVideoPlayer from '../../components/TheVideoPlayer';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="Video">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>
            Tilslutning af slange til John Guest
          </Heading1>
          <Paragraph>
            Man behøver ikke noget værktøj for at tilslutte en slange til en John Guest.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <TheVideoPlayer url="YNEQ44stLgA" thumbnail="john-guest" />
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>
            Udskrift af video
          </Heading3>
          <Paragraph>
            Man behøver ikke noget værktøj for at tilslutte en slange til en John Guest.
          </Paragraph>
          <Paragraph>
            Du sætter blot slangen ind og så sidder den fast. Sådan her.
          </Paragraph>
          <Paragraph>
            Når du skal have slangen ud igen, skal du trykke studsen tilbage og slangen hives ud.
          </Paragraph>
          <Paragraph>
            For at indstille trykke til f.eks. 6 bar skruer man her - med uret.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
